import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppRoutes } from '@app/core/routing';
import { Logout, AuthService } from '@app/state';
import { Store } from '@ngxs/store';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TenantService } from '@app/core/services/tenant.service';
import { toApiError } from '@app/core/errors';

@Injectable({ providedIn: 'root' })
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private auth: AuthService,
    private tenant: TenantService,
    private store: Store,
    private router: Router
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.auth.jwt ? this.auth.jwt : null;

    if (token) {
      request = request.clone({
        headers: request.headers.set('Authorization', 'Bearer ' + token),
      });
    } else {
      request = request.clone({
        headers: request.headers,
      });
    }
    if (this.tenant.getTenant()) {
      request = request.clone({
        headers: request.headers.append('X-Tenant-Domain', this.tenant.getTenant()),
      });

      // Add live header if in live mode
      if (this.tenant.getLiveMode()) {
        request = request.clone({
          headers: request.headers.append('Live', 'true'),
        });
      }
    } else {
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          // Clear the stale token everywhere, but only eject the user from an auth-guarded
          // area. A background call (e.g. charity/statistics) carrying an expired JWT must
          // never navigate an anonymous donor away from checkout or a campaign page.
          // `Logout` never redirects here, so this is the one navigation: straight to login,
          // where `error=401` shows the expired-session message.
          const returnUrl = this.router.url;
          const inGuardedArea = /^\/(dashboard|create)(\/|\?|$)/.test(returnUrl);
          this.store.dispatch(new Logout(true, true)).subscribe(() => {
            if (inGuardedArea) {
              this.router.navigate([AppRoutes.auth.login()], {
                queryParams: { returnUrl, error: '401' },
              });
            }
          });
        }

        return throwError(() => toApiError(error));
      })
    );
  }
}
